//TODO: valorate implementing the Web Storage API interface
// skipcq: JS-0327
export default class Cookie {
    static getCookie(name: string): string | undefined {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop()?.split(";").shift();
    }

    static removeCookie(name: string): void {
        document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    }
}
